import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServiceFormatter } from '../../helpers/service-formatter';
import { GridResponse, MaoFileDataItem } from '../../models/grid-data';
import { CmsFileDataRequest } from '../../models/mor-file-processed-data-request';

@Injectable({
  providedIn: 'root'
})
export class CmsFileService {
  private endpoint = ServiceFormatter.endpoint;
  
  constructor(private http: HttpClient) {}

  getCmsFileData(request: CmsFileDataRequest) {
    return this.http.post<GridResponse<MaoFileDataItem>>(`${this.endpoint}FileData/cms-file-data`, request, ServiceFormatter.getHttpOptions());
  }
}